import { render, staticRenderFns } from "./ScrollPanel.vue?vue&type=template&id=6aff5d1c"
import script from "./ScrollPanel.vue?vue&type=script&lang=js"
export * from "./ScrollPanel.vue?vue&type=script&lang=js"
import style0 from "./ScrollPanel.vue?vue&type=style&index=0&id=6aff5d1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports